import React from 'react';
import { TableRow } from 'semantic-ui-react';

import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import OrchardTableCell from './components/OrchardTableCell';
import BlocksTableCell from './components/BlocksTableCell';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetBlocksTableRow(
    props: Props
): React.ReactElement {
    const { entitySummaryIndex, pageIndex } = props;

    return (
        <TableRow>
            <OrchardTableCell
                entitySummaryIndex={entitySummaryIndex}
                pageIndex={pageIndex}
            />
            <BlocksTableCell
                entitySummaryIndex={entitySummaryIndex}
                pageIndex={pageIndex}
            />
        </TableRow>
    );
}
